import React from "react";

import Navbar from "./Navbar";

const Header = () => {
  return (
    <>
      {/* <div id="cover" /> */}
      <header>
        <Navbar />
      </header>
    </>
  );
};

export default Header;
